<template>
  <div>
    <page-title
        :left-btns="leftBtns"
        :right-btns="rightBtns"
        @leftClick="leftClickHandler"
        @rightClick="rightClickHandler"
    ></page-title>
    <ra-search-box
        class="mt-4"
        :search-fields="searchColumns"
        @search="searchHandler"
        @clear="clearSearchHandler"
    ></ra-search-box>
    <div class="mt-4" v-loading="loading">
      <el-table
          v-if="tableData.length"
          :data="tableData"
      >
        <el-table-column
            v-for="(item, index) in column"
            :label="item.label"
            :prop="item.key"
            :key="index"
            :width="item.minWidth"
        >
          <template v-slot:default="scope">
            <template v-if="item.prop === 'picture'">
              <div>
                <el-image fit="cover" class="w-[60px] h-[40px]" :src="scope.row.picture" alt="" :preview-src-list="[scope.row.picture]" />
              </div>
            </template>
            <template v-else>
              <span>{{ scope.row[item.prop] }}</span>
<!--              <el-tooltip :disabled="!item.showToolTip" :content="scope.row[item.prop]">-->
<!--              </el-tooltip>-->
            </template>
          </template>
        </el-table-column>
        <el-table-column
            label="Action"
            v-if="activeName === 'rewards'"
        >
          <template slot-scope="scope">
            <div class="action">
              <span v-if="scope.row.status === 1" class="cursor-pointer" @click="activeHandler(scope.row)">
                <img src="../../assets/zipCode/activate@2x.png" class="w-4 mr-4" alt="">
              </span>
              <span v-else @click="activeHandler(scope.row)" class="cursor-pointer">
                  <img src="../../assets/zipCode/ban@2x.png" class="w-4 mr-4" alt="">
              </span>
              <span @click="deleteHandler(scope.row)" class="cursor-pointer">
                <img src="../../assets/zipCode/delete@2x.png" class="w-4 mr-4" alt="">
              </span>
              <span @click="editHandler(scope.row)" class="cursor-pointer">
                <img src="../../assets/zipCode/edit@2x.png" class="w-4 mr-4" alt="">
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Action"
          v-if="activeName === 'requests'"
        >
          <template slot-scope="scope">
            <div class="Status">
              <el-switch
                :active-value="2"
                :inactive-value="1"
                v-model="scope.row.is_processing"
                @change="changeProceHandle(scope.row)"
                active-color="#82D237"
                inactive-color="#ccc">
              </el-switch>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <table-empty v-else></table-empty>
      <ra-pagination
          :currentPage="searchQuery.page"
          :list-length="tableData.length"
          @pageChange="pageHandler"
          :total="total"
      ></ra-pagination>
    </div>
    <create-and-edit
        :edit-row="editRow"
        @updateList="updateHandle"
        @closeEditor="cloeEditorHandle"
        v-if="editDialogVisible"
        ref="dialog"></create-and-edit>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="530px">
      <div class="mt-6 text-[14px] font-normal text-[#1F2D42 ]">{{handleText}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" plain class="w-[80px] changeFocus border-black text-black">No</el-button>
        <el-button type="success" class="w-[80px] p-0" @click="dialogHandler">Yes</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {searchColumns} from "@/view/redemption/column";
import createAndEdit from "@/view/redemption/create-and-edit.vue";
import {
  getRedemptionList,
  deleteRedemption,
  getRedemptionHistory,
  updateRedemptionStatus,
  getRedemptionRequests, updateRedemptionRequest
} from "@/api/redemption";
import { EventBus } from '@/api/eventBus';
export default {

  name: 'redemption-page',
  components: {
    createAndEdit
  },
  data() {
    return {
      tableData: [],
      editRow: {},
      dialogVisible: false,
      editDialogVisible: false,
      dialogTitle: '',
      handleText: '',
      handleType: '',
      handleRow: '',
      searchColumns,
      activeName: 'rewards',
      // Redemption
      leftBtns: [
        {
          label: 'Rewards',
          name: 'rewards'
        },
        {
          label: 'Log',
          name: 'log',
        },
        {
          label: 'Requests',
          name:'requests'
        }
      ],
      rightBtns: [
        {
          label: 'New',
          name: 'new',
          bgColor: '#e95646',
        }
      ],
      searchParams: {
        redemptionType: 'reWordNo',
        reWordNo: ''
      },
      column: [],
      columnList: [
        {label: 'Reward No.', prop: 'reward_no'},
        {label: 'Type', prop: 'type_text'},
        {label: 'Reward Name', prop: 'reward_name', showToolTip: true},
        {label: 'Points needed', prop: 'points_needed'},
        {label: 'Picture', prop: 'picture'},
        {label: 'term of use', prop: 'term_of_use', showToolTip: true},
      ],
      columnLog: [
        {label: 'Reward No.', prop: 'reward_no'},
        {label: 'Reward  Name', prop: 'reward_name'},
        {label: 'Redeemer', prop: 'username', minWidth: 260},
        {label: 'UID', prop: 'uid'},
        {label: 'Redemption time', prop: 'redemption_time'},
      ],
      columneRquests: [
        {label: 'Reward No.', prop: 'reward_no'},
        {label: 'Requested Reward', prop: 'reward_name'},
        {label: 'Redeemer', prop: 'username', minWidth: 260},
        {label: 'UID', prop: 'uid'},
        {label: 'Redeemer email', prop: 'email'},
        {label: 'Redemption time', prop: 'redemption_time'},
      ],
      searchQuery: {
        page: 1,
      },
      total: 0,
      loading: false
    }
  },
  created() {
    this.column = this.columnList
    this.getList()
  },
  beforeDestroy() {
    EventBus.$off('updateNum')
  },
  methods: {
    changeProceHandle(row){
      updateRedemptionRequest({
       id:row.id,
        is_processing:row.is_processing
      }).then(res=>{
        if (res.code == 200){
          EventBus.$emit('updateNum');
          this.$message.success(res.msg);
        }else {
          this.$message.error(res.msg);
        }
      })
    },
    getList(params = {}) {
      console.log(params,'params')
      this.loading = true
      if (this.activeName === 'rewards') {
        getRedemptionList({
          page: this.searchQuery.page,
          limit: 10,
          ...params
        }).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.tableData = res.data.data
            this.total = res.total
          } else {
            this.$message.error(res.msg)
          }
        })
      }
     else if (this.activeName === 'log') {
        getRedemptionHistory({
          page: this.searchQuery.page,
          limit: 10,
          ...params
        }).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.tableData = res.data.list
            this.total = res.total
          } else {
            this.$message.error(res.msg)
          }
        })
      }else{
        getRedemptionRequests({
          page:this.searchQuery.page,
          limit:10,
          ...params
        }).then(res=>{
          this.loading = false
          if (res.code === 200) {
            this.tableData = res.data.list
            // this.tableData = [
            //   {}
            // ]
            this.total = res.total
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    pageHandler(page) {
      this.searchQuery.page = page;
      // getList(this.searchQuery).then(res => {
      //
      // })
    },
    updateHandle() {
      this.editRow = {}
      this.getList()
    },
    cloeEditorHandle() {
      this.editDialogVisible = false
    },
    searchHandler(params) {
      console.log(params,'pare')
      this.searchQuery.page = 1;
      this.getList(params)
    },
    clearSearchHandler(params) {
      this.getList(params)
    },
    leftClickHandler(name) {
      console.log(this.searchColumns,'ddd')
      this.searchColumns[0].options = [
        { label: 'Reward No', value: 'reward_no' },
        { label: 'Reward Name', value: 'name' },
        { label: 'Term Of Use', value: 'term_of_use' },
      ]
      if (name === 'log') {
        this.activeName = 'log';
        this.column = this.columnLog
      }else if (name === 'rewards') {
        this.column = this.columnList
        this.activeName = 'rewards';
      }else {
        this.column = this.columneRquests
        this.activeName = 'requests'
        this.searchColumns[0].options = [
          { label: 'Reward No.', value: 'reward_no' },
          { label: 'Redeemer', value: 'username' },
          { label: 'UID', value: 'uid' },
          { label: 'Redeemer email', value: 'email' },
        ]
      }
      this.getList()
    },
    rightClickHandler(name) {
      this.editRow = {};
      if (name === 'new') {
        this.editDialogVisible = true;
      }
    },
    activeHandler(row) {
      this.handleRow = row
      this.dialogVisible = true;
      if (row.status === 1) {
        this.dialogTitle = 'Deactivate this reward'
        this.handleText = 'Will you deactivate this reward? The reward will be invisible.';
      } else {
        this.dialogTitle = 'Activate this reward'
        this.handleText = 'Will you activate this reward? The reward will be visible.';
      }
      this.handleType = 'updateStatus'
    },
    deleteHandler(row) {
      this.dialogVisible = true;
      this.dialogTitle = 'Delete this reward'
      this.handleText = 'Will you delete this reward?  The reward cannot be redeemed anymore.';
      this.handleType = 'delete'
      this.handleRow = row
    },
    dialogHandler() {
      if (this.handleType === 'delete') {
        // 执行删除逻辑
        deleteRedemption({id: this.handleRow.id}).then(res => {
          if (res.code === 200) {
            this.$message.success('Successfully deleted')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (this.handleType === 'updateStatus') {
        // 执行deactivate逻辑
        updateRedemptionStatus({ id: this.handleRow.id, status: this.handleRow.status === 1 ? 0 : 1 }).then(res => {
          if (res.code === 200) {
            this.$message.success('Status updated successfully')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    editHandler(row) {
      this.editRow = row;
      this.editDialogVisible = true;
    },
  }
}
</script>


<style scoped lang="less">
/deep/.el-switch{
  height: auto;
}
</style>
